import { type ReactNode } from 'react';

interface PaginaListaProps {
  cabecalho: ReactNode;
  /** Indicadores acima da lista (opcional). */
  indicadores?: ReactNode;
  filtros?: ReactNode;
  /** A tabela ocupa o resto da altura e rola por dentro. */
  lista: ReactNode;
  /** Gaveta de detalhe (fica fora do fluxo). */
  detalhe?: ReactNode;
}

/** Página de lista com detalhe em gaveta: cabeçalho, indicadores, filtros e tabela que rola. */
export function PaginaLista({ cabecalho, indicadores, filtros, lista, detalhe }: PaginaListaProps) {
  return (
    <div className="flex h-full min-h-0 flex-col gap-5">
      {cabecalho}
      {indicadores && <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">{indicadores}</div>}
      {filtros}
      <div className="flex min-h-80 flex-1 flex-col">{lista}</div>
      {detalhe}
    </div>
  );
}
